import "core-js/modules/es.array.iterator";
import "core-js/modules/es.promise";

let common = require('./modules/common');
let cart = require('./modules/cart');
let tracking = require('./modules/tracking');
let modals = require('./modules/modals');

let _internals = {
    updateQuantity: function (sku, quantity) {
        cart.update(sku, quantity, '', false, function (data) {
            if (data.result === 'success') {
                _internals.render(data);
            }
        });
    },
    render: function (data) {
        if (data.total.positions === 0) {
            window.location.reload();
        }

        $('#cartCostText').html(
            `В корзине <b>${(data.total.positions > 0) ? data.total.positions : "нет"}</b> ${common.noun(data.total.positions, "товар", "товара", "товаров")}`
        );

        let bonusHolder = $('#bonusAmount');
        let bonusBlock = $('#bonusBlock');

        if (bonusHolder) {
            if (data.loyalty.bonus === undefined || data.loyalty.bonus === 0) {
                bonusBlock.addClass('hidden');
            } else {
                bonusBlock.removeClass('hidden');
                bonusHolder.html(data.loyalty.bonus);
            }
        }

        $('#cartSellCostValue').html(_internals.formatCurrency(data.total.sell_cost));
        $('#cartCostValue').html(_internals.formatCurrency(data.total.cost));

        let rows = [];

        $.each(data.positions, function (id, position) {
            $('input#product-' + id + '-qty').val(Number(position.quantity));
            $('.total[data-id="' + id + '"]').html(_internals.formatCurrency(position.total));
            $('.cart-price[data-id="' + id + '"] > .cart-price-current').html(_internals.formatCurrency(position.user_price));
            let oldPrice = $('.cart-price[data-id="' + id + '"] > .cart-price-old');
            oldPrice.html(_internals.formatCurrency(position.price));
            if (position.price > position.user_price) {
                oldPrice.show();
            } else {
                oldPrice.hide();
            }
            rows.push(id);
        });

        $('.cart-row[data-id]').not(function () {
            return rows.indexOf($(this).data('id').toString()) >= 0;
        }).remove();
    },
    formatCurrency: function (number) {
        let x = +number;

        if (isNaN(x)) {
            x = 0;
        }

        return x.formatMoney(0, '', ' ') + ' р.';
    }
};

$('input[data-action="cart-quantity-change"]').on('change', function () {
    let input = $(this);
    let id = input.data('id');

    let quantity = +input.val();

    _internals.updateQuantity(id, quantity);
});

$('button[data-action="remove-from-cart"]').on('click', function () {
    _internals.updateQuantity($(this).data('id'), 0);
});